module.exports = __webpack_public_path__ + "static/media/logo11.b456dc05.png";